module.exports = __webpack_public_path__ + "static/media/journey-icon.7891179c.svg";